import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FindInPageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"find_in_page"}/>
}
